export const Wave = () => (
    <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="nonzero" fill="none">
            <path d="M0 0v100h1440V0c-215.16 20.04-460.111 31.38-720 31.38S215.156 20.04 0 0Z" fill="#2c2c2b" />
        </g>
    </svg>
);
